import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_SUPPLIERS](state, data) {
    state.allSuppliers = data
  },
  [types.SAVE_SUPPLIER](state, data) {
    state.allSuppliers.push(data)
  },
}
